<template>
  <div class="page fs16">
    <!-- banner -->
    <el-carousel :interval="5000" height="500px" arrow="always">
      <!-- <el-carousel-item
        class="bg-cover csp"
        style="background-image: url(https://static.wkanx.com/w002/M00/05/D1/CgIXgV6O5_SAG7__AAITrgieaMA381.jpg)"
        @click.native="showContactForm = true"
      >
        <img
          src="https://static.wkanx.com/w002/M00/07/DE/CgIXGF9YRYmAHxR6AABjaXwzQnA387.png"
          width="433"
          class="abs-center-hv"
        />
      </el-carousel-item> -->
      <el-carousel-item
        class="bg-cover tc color-white bg-bottom"
        style="background-image: url(https://static.wkanx.com/w002/M00/05/C9/CgIXgV6Nn82AKavPAAUi1-0ekpk821.jpg)"
      >
        <div class="abs-center-hv">
          <div style="transform: translate(0, -60px)">
            <div class="fs28 fwb m-b-5" style="letter-spacing: 6px">连接创造美好</div>
            <div class="fs16">连尚广告平台助力您实现商业目标</div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="rel tc bg-gray oh p-t-6">
      <div class="fs18 fwb m-t-6">选择连尚广告的理由</div>
      <div class="container bc m-t-4 m-b-8 tl">
        连尚广告凭借强大产品用户数优势，卡位碎片化上网的第一步，为客户提供全系列产品的广告资源覆盖用户移动上网场景。
      </div>
      <img src="https://static.wkanx.com/w002/M00/05/AF/CgIXlV6C6rGABr9yAAI6EP7zw2Q801.png" width="500" />
    </div>
    <div class="p-t-5 tc p-b-8">
      <div class="fs18 fwb m-t-5 m-b-7">新潜力族群“小镇青年”聚合平台，享受下沉流量红利</div>
      <div flex="main:center" class="sm-container m-t-4 m-b-6">
        <div flex-box="0" style="width: 33.33%">
          <img src="https://static.wkanx.com/w002/M00/05/AF/CgIXgV6C7baAaMGGAAAJcawzdPc763.png" width="82" alt />
          <div class="m-t-3 m-b-1">地域分布</div>
          <div>62%在三线及以下城市</div>
        </div>
        <div flex-box="0" style="width: 33.33%">
          <img src="https://static.wkanx.com/w002/M00/05/AF/CgIXlV6C7fGAbycKAAAYavN545w048.png" width="82" alt />
          <div class="m-t-3 m-b-1">男女画像比例</div>
          <div>6 : 4</div>
        </div>
        <div flex-box="0" style="width: 33.33%">
          <img src="https://static.wkanx.com/w002/M00/05/AF/CgIXGF6C7fqAcJZ3AAAcq_iHkLw320.png" width="82" alt />
          <div class="m-t-3 m-b-1">18-40岁占比</div>
          <div>60%以上</div>
        </div>
      </div>
    </div>
    <div class="bg-gray p-v-8">
      <div class="m-t-8 m-b-6 tc fs18 fwb">将客户的广告展现给精准用户</div>
      <div class="container m-b-8 bc m-t-2 tc">
        <div class="m-b-8">
          拥有行业领先的算法能力和资讯推荐能力，识别每一位用户真实需求及兴趣爱好，DMP平台符合用户隐私安全的同时，为用户标签赋能
        </div>
        <img width="200" src="https://static.wkanx.com/w002/M00/05/B0/CgIXGF6DAKOAIgxnAADuktcPU5U167.png" alt />
      </div>
    </div>
    <div class="p-v-8">
      <div class="m-t-8 m-b-4 tc fs18 fwb">更精准的场景化广告投放</div>
      <div class="container tc">
        <div class="m-b-8">
          根据 WiFi SSID定位 + APP深度数据，精准匹配商旅人群，如机场、高铁站等
        </div>
        <img src="https://static.wkanx.com/w002/M00/05/B0/CgIXgV6DAvqALp2KAADOWUvpTO0166.png" width="200" alt />
      </div>
    </div>
    <div class="bg-gray p-v-8">
      <div class="m-t-8 tc fwb">投放平台向的能力升级</div>
      <div class="container m-t-4">
        1.广告创编流程精简，提升广告搭建效率，支持多维度定向能力，轻松找到更合适的人群。
      </div>
      <div class="container m-t-4">
        2.UI全新改版，数据更清晰，广告链路全流程把控。
      </div>
      <div style="height: 50px;"></div>
      <!-- <div class="m-b-8 m-t-8 tc">
        <img width="380" src="https://static.wkanx.com/w002/M00/05/B0/CgIXlV6DBJeAL9YcAABScyN4Ppk358.png" alt />
      </div> -->
    </div>
    <div class="tc p-v-8">
      <div class="m-t-8 fs18 fwb">帮助客户实现商业目标</div>
      <div class="container m-t-4">
        通过持续升级核心广告产品策略，助力客户达成效果和品牌曝光等目的，实现商业目标
      </div>
      <div class="m-b-8 m-t-8 tc">
        <img width="600" src="https://static.wkanx.com/w002/M00/05/B0/CgIXGF6DBf-AVvg9AAW0iCsLCu8973.png" alt />
      </div>
    </div>
    <div class="p-v-8">
      <div class="fs18 tc m-b-2 fwb">通过连尚广告平台获取更多客户</div>
    </div>
    <ContactForm :show="showContactForm" @hide="showContactForm = false" />
  </div>
</template>

<script>
import ContactForm from '@/components/ContactFormDialog';
export default {
  components: { ContactForm },
  data() {
    return {
      showContactForm: false,
    };
  },
};
</script>
